import React from 'react';
import { TransactionData } from '../utils/transactionUtils';
import { getStatusConfig } from '../utils/statusUtils';

interface TransactionStatusProps {
  transaction: TransactionData | null;
}

export const TransactionStatus: React.FC<TransactionStatusProps> = ({ transaction }) => {
  if (!transaction) return null;

  const statusConfig = getStatusConfig(transaction.status, transaction.expectedPaymentSendDate);

  return (
    <div
      className={`flex justify-between items-center w-full gap-4 border-b border-[rgba(138,146,171,0.20)] pb-4 max-[400px]:flex-col max-[400px]:justify-center max-[400px]:items-center`}
    >
      <span className='text-main text-sm font-medium'>Status</span>
      <div
        className={`justify-center items-center rounded-[12px] p-2 font-bold ${statusConfig.bgColorClass} ${statusConfig.colorClass}`}
      >
        {statusConfig.label}
      </div>
    </div>
  );
};

